import AuthProvider from "./provider/AuthProvider";
import LanguageProvider from "./provider/LanguageProvider";
import InstalledAppsProvider from "./provider/InstalledAppsProvider";
import DictionaryProvider from "./provider/DictionaryProvider";
import { PresenceProvider } from "./provider/PresenceProvider";
import { ConfirmHost } from "./components/ui/ConfirmDialog";
import Routes from "./routes";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <InstalledAppsProvider>
          <DictionaryProvider>
            <PresenceProvider>
              <Routes />
              <ConfirmHost />
            </PresenceProvider>
          </DictionaryProvider>
        </InstalledAppsProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
